import * as React from "react";
import { useScroll } from "@react-three/drei";

type Props = {
  onEl: (el: HTMLDivElement | null) => void;
};

export function ScrollElBridge({ onEl }: Props) {
  const scroll = useScroll();

  React.useEffect(() => {
    onEl(scroll.el);
    return () => onEl(null);
  }, [onEl, scroll.el]);

  return null;
}
